import React, { useState } from 'react'
import { Elements } from '@stripe/react-stripe-js';
import SetupForm from '../../components/SetupForm';
import { toast } from 'react-toastify';

const AddStripeCard = ({ loading, clientSecret, showForm, setShowForm, stripePromise, getSavedCards }) => {
    if (loading) { return <div className="text-center p-6">Loading...</div> }

    const options = {
        clientSecret: clientSecret || null,
        appearance: {
            theme: 'stripe',
            variables: {
                colorPrimary: '#635BFF',
                colorBackground: '#ffffff',
                colorText: '#30313d',
                colorDanger: '#df1b41',
                fontFamily: 'system-ui, sans-serif',
                fontSizeBase: '16px',
                spacingUnit: '4px',
                borderRadius: '8px',
            }
        }
    };

    return (<>
        {showForm && clientSecret && (
            <Elements stripe={stripePromise} options={options}>
                <SetupForm onCardSaved={() => { toast.success("Card saved successfully!"); getSavedCards() }} setShowForm={setShowForm} />
            </Elements>
        )}
    </>)
}

export default AddStripeCard